import {SoundDuckConfig} from '@gongxigames/framework/slot/types';

export class SoundsDuckingConfig {
    /**
     * [name of the soundManager that triggers ducking of the music]
     */
    private static _duckingConfigMap = new Map<string, SoundDuckConfig>();

    public static hasDuckingFor(soundName: string): boolean {
        return this._duckingConfigMap.has(soundName);
    }

    public static getDuckingConfig(soundName: string): SoundDuckConfig|undefined {
        return this._duckingConfigMap.get(soundName);
    }

    /**
     * @deprecated
     * all duck properties should be described in GameAudioConfig.ts,
     * for example:
     * gameAudioConfig.properties['soundName'] = {
     *     duck: {volume: 0.1, fadeDuration: 300}
     * }
     */
    public static addSound(soundName: string, fadeDuration: number): void {
        this._duckingConfigMap.set(soundName, {volume: 0.1, fadeDuration});
    }

    public static addDuckingConfig(soundName: string, duckConfig: SoundDuckConfig): void {
        this._duckingConfigMap.set(soundName, duckConfig);
    }
}
